// extracted by mini-css-extract-plugin
module.exports = {"root":"_3P-b1","iframe":"_2mgS5","loaderContainer":"T93-g"};